import React, { useMemo, useState } from "react";

import MenuItemOptionGroupType from "api/types/MenuItemOptionGroup";

import MenuItemOptionGroup from "./MenuItemOptionGroup";
import SelectedOption from "./SelectedOption";

interface MenuItemOptionGroupsProps {
	menuItemOptionGroups: MenuItemOptionGroupType[];

	defaultValue?: SelectedOption[];

	onChange?(event: { value: SelectedOption[] }): void;
}

const MenuItemOptionGroups = ({ menuItemOptionGroups, defaultValue, onChange }: MenuItemOptionGroupsProps) => {
	const [_value, setValue] = useState(defaultValue || []);

	const handleChange = useMemo(
		() => ({
			menuItemOptionGroup,
			selection
		}: {
			menuItemOptionGroup: MenuItemOptionGroupType;
			selection: null | SelectedOption[];
		}) => {
			setValue(prevValue => {
				const nextValue = [
					...prevValue.filter(x => x.menuItemOptionGroupId !== menuItemOptionGroup.id),
					...(selection ? selection : [])
				];

				onChange && onChange({ value: nextValue });

				return nextValue;
			});
		},
		[onChange]
	);

	return (
		<>
			{menuItemOptionGroups.map(menuItemOptionGroup => (
				<MenuItemOptionGroup
					key={menuItemOptionGroup.id}
					menuItemOptionGroup={menuItemOptionGroup}
					defaultValue={defaultValue}
					onChange={handleChange}
				/>
			))}
		</>
	);
};

export default MenuItemOptionGroups;
